import { render, staticRenderFns } from "./MajorParentForm.vue?vue&type=template&id=25038dfc&scoped=true"
import script from "./MajorParentForm.vue?vue&type=script&lang=js"
export * from "./MajorParentForm.vue?vue&type=script&lang=js"
import style0 from "./MajorParentForm.vue?vue&type=style&index=0&id=25038dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25038dfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
